import type {
    FutureStockQuantities,
    ProductOrderRestriction,
    StockMessageValues,
    StockQuantity,
} from '../types';
import getGeneralStockStatuses from './getGeneralStockStatuses';
import {
    singleStockMessageKey,
    mixedStockMessageKey,
} from './stockMessageKeys';

const getMixedStatuses = (props: {
    store: string;
    stock: StockQuantity[];
    futureStock: FutureStockQuantities[];
    restriction: ProductOrderRestriction[];
    currentStockOnly?: boolean;
}): { messageId: string; values?: StockMessageValues }[] => {
    const generalStockStatuses = getGeneralStockStatuses(props);

    if (!generalStockStatuses.isMixed) {
        return [
            {
                messageId: singleStockMessageKey[generalStockStatuses.status],
            },
        ];
    }

    return [
        {
            messageId: mixedStockMessageKey[generalStockStatuses.status],
        },
    ];
};

export default getMixedStatuses;
